import { useEffect, useState } from "react";

const styles = `
  @keyframes title-glow {
    0%, 100% { 
      text-shadow: 0 4px 20px rgba(var(--color-primary-rgb, 59, 130, 246), 0.2);
      filter: brightness(1);
    }
    50% { 
      text-shadow: 0 4px 30px rgba(var(--color-primary-rgb, 59, 130, 246), 0.35);
      filter: brightness(1.05);
    }
  }
  @keyframes subtitle-slide {
    from { 
      opacity: 0; 
      transform: translateY(20px); 
      filter: blur(8px);
    }
    to { 
      opacity: 1; 
      transform: translateY(0); 
      filter: blur(0);
    }
  }
  @keyframes scale-in {
    from { 
      opacity: 0; 
      transform: scale(0.85); 
      filter: blur(15px);
    }
    to { 
      opacity: 1; 
      transform: scale(1); 
      filter: blur(0);
    }
  }
  @keyframes sparkle {
    0%, 100% { opacity: 0.4; transform: scale(1) rotate(0deg); }
    50% { opacity: 1; transform: scale(1.3) rotate(180deg); }
  }
`;

export const EventHeader = () => {
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    const isDarkMode = document.documentElement.getAttribute('data-theme') === 'dark';
    setIsDark(isDarkMode);
  }, []);

  return (
    <>
      <style>{styles}</style>
      <div 
        style={{
          textAlign: 'center',
          paddingTop: 'clamp(24px, 6vw, 48px)',
          position: 'relative',
        }}
      >
        
        
        {/* Sparkle decorations */}
        <div style={{ position: 'absolute', top: '20px', left: '15%', animation: 'sparkle 2.5s ease-in-out infinite' }}>
          <span style={{ color: 'var(--color-primary)', fontSize: 'clamp(14px, 3vw, 20px)' }}>✦</span>
        </div>
        <div style={{ position: 'absolute', top: '35px', right: '20%', animation: 'sparkle 2.5s ease-in-out infinite 0.7s' }}>
          <span style={{ color: 'var(--color-accent)', fontSize: 'clamp(12px, 2.5vw, 16px)' }}>✦</span>
        </div>
        <div style={{ position: 'absolute', top: '50px', left: '25%', animation: 'sparkle 2.5s ease-in-out infinite 1.2s' }}>
          <span style={{ color: 'var(--color-secondary)', fontSize: 'clamp(10px, 2vw, 12px)' }}>✦</span>
        </div>
        
        <p 
          style={{
            fontSize: 'clamp(0.85rem, 3vw, 1.25rem)',
            color: isDark ? 'var(--color-text-secondary)' : 'var(--color-secondary)',
            fontWeight: 500,
            letterSpacing: '3px',
            textTransform: 'uppercase',
            animation: 'subtitle-slide 0.8s ease-out 0.3s backwards',
            fontFamily: "'Montserrat', sans-serif",
            marginBottom: 'clamp(12px, 3vw, 20px)',
          }}
        >
          <span style={{ color: 'var(--color-primary)' }}>✧</span>
          {' '}Explore Events{' '}
          <span style={{ color: 'var(--color-accent)' }}>✧</span>
        </p>

        {/* Bottom decorative line */}
        <div 
          style={{
            width: 'min(120px, 30vw)',
            height: '3px',
            margin: '0 auto',
            background: `linear-gradient(90deg, var(--color-primary), var(--color-accent))`,
            borderRadius: '3px',
            animation: 'subtitle-slide 0.8s ease-out 0.5s backwards',
            boxShadow: `0 2px 12px rgba(var(--color-primary-rgb, 59, 130, 246), 0.3)`,
          }}
        />
      </div>
    </>
  );
};